import React from 'react';
import { Box, Grid } from '@mui/material';
import { ButtonUI, DialogUI } from '../../Interface';
import AlertFormUsersTable from './AlertFormUsersTable';
import AlertFormSchedule from './AlertFormSchedule';
import { useFormikContext } from 'formik';
import { AlertTypeEnum } from '../../../config/alert';

const AlertFormDialog = (props) => {
  const { open, onClose, autocompleteData, name } = props;
  const { values } = useFormikContext();

  const label = `Riasztás részletei - ${name}`;
  const relevantUsers = autocompleteData?.user.filter((user) => user.archive === 'N' && user.deletedBy === null);
  const roles = autocompleteData?.roles ?? [];

  return (
    <DialogUI open={open} onClose={onClose} headerContent={label} maxWidth="xl" fullWidth>
      <Grid container spacing={2}>
        {values.type !== AlertTypeEnum.SCHEDULED_TASK ? (
          <Grid item xs={12} md={7}>
            <AlertFormUsersTable users={relevantUsers} roles={roles} />
          </Grid>
        ) : null}

        <Grid
          item
          xs={12}
          md={values.type === AlertTypeEnum.SCHEDULED_TASK ? 12 : 5}
          container
          alignItems="center"
        >
          <AlertFormSchedule />
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="center" gap="0.5rem" mt="1rem">
        <ButtonUI text="Ok" className="bg-success" onClick={onClose} />
        <ButtonUI text="Mégsem" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default AlertFormDialog;
